/**
 * @generated SignedSource<<c67e93942e3163543495b24f4de77a36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type standaloneCreateInvoiceModalV2_viewer$data = {
  readonly id: string;
  readonly backendId: number | null;
  readonly firstName: string | null;
  readonly actualPersonId: string | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly company: {
    readonly currency: string | null;
    readonly invoiceLastSequence: number | null;
    readonly invoiceQuantityDecimals: number | null;
    readonly dateEffectiveExchangeRates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly currency: string | null;
          readonly rate: number | null;
          readonly startDate: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly modules: ReadonlyArray<{
      readonly moduleType: string | null;
    } | null> | null;
    readonly clients: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
        } | null;
      } | null> | null;
    } | null;
    readonly allPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PersonDropdown_persons">;
      } | null> | null;
    } | null;
  } | null;
  readonly project?: {
    readonly id: string;
    readonly name: string | null;
    readonly projectColor: string | null;
    readonly isInProjectGroup: boolean | null;
    readonly companyProjectId: number | null;
    readonly projectGroupId: string | null;
    readonly currencyExchangeRate: number | null;
    readonly budgetType: BUDGET_TYPE | null;
    readonly defaultPeriodBudgetType: PERIOD_BUDGET_TYPE | null;
    readonly status: PROJECT_STATUS | null;
    readonly budget: number | null;
    readonly projectEndYear: number | null;
    readonly projectEndMonth: number | null;
    readonly projectEndDay: number | null;
    readonly fullAccessToProject: boolean | null;
    readonly rateCard: {
      readonly id: string;
      readonly name: string | null;
      readonly currency: string | null;
      readonly parentRateCardId: string | null;
      readonly defaultRate: number | null;
      readonly rates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly rate: number | null;
            readonly startDate: string | null;
            readonly defaultRate: boolean | null;
            readonly role: {
              readonly id: string;
              readonly name: string | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly client: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly clientContact: {
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
    } | null;
    readonly invoiceTotals: ReadonlyArray<{
      readonly invoiceId: string;
      readonly createdDay: number | null;
      readonly createdMonth: number | null;
      readonly createdYear: number | null;
      readonly invoicedWithoutTax: number | null;
      readonly invoicedWithoutTaxBaseCurrency: number | null;
      readonly invoicedWithoutTaxProjectCurrency: number | null;
    } | null> | null;
    readonly unInvoicedTotal: {
      readonly unInvoicedMinutes: number | null;
      readonly unInvoicedPrice: number | null;
    };
    readonly expenseItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly approved: boolean | null;
          readonly expenseYear: number | null;
          readonly expenseMonth: number | null;
          readonly expenseDay: number | null;
          readonly billable: boolean | null;
          readonly partOfFixedPrice: boolean | null;
          readonly price: number | null;
          readonly cost: number | null;
          readonly quantity: number | null;
          readonly planned: boolean | null;
          readonly createdAt: string | null;
          readonly invoiceId: number | null;
          readonly invoiced: boolean | null;
          readonly deliverable: {
            readonly id: string;
            readonly price: number | null;
          } | null;
          readonly person: {
            readonly id: string;
            readonly fullName: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
          } | null;
          readonly phase: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly retainerPeriods: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly endYear: number | null;
          readonly endMonth: number | null;
          readonly endDay: number | null;
          readonly periodPriceAmount: number | null;
          readonly periodHoursAmount: number | null;
          readonly periodLocked: boolean | null;
          readonly invoiced: boolean | null;
          readonly sharedPeriodDifferencePriceAmount: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
  } | null;
  readonly projects?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly projectColor: string | null;
        readonly isInProjectGroup: boolean | null;
        readonly companyProjectId: number | null;
        readonly projectGroupId: string | null;
        readonly currencyExchangeRate: number | null;
        readonly budgetType: BUDGET_TYPE | null;
        readonly defaultPeriodBudgetType: PERIOD_BUDGET_TYPE | null;
        readonly status: PROJECT_STATUS | null;
        readonly budget: number | null;
        readonly projectEndYear: number | null;
        readonly projectEndMonth: number | null;
        readonly projectEndDay: number | null;
        readonly fullAccessToProject: boolean | null;
        readonly invoiceTotals: ReadonlyArray<{
          readonly invoiceId: string;
          readonly createdDay: number | null;
          readonly createdMonth: number | null;
          readonly createdYear: number | null;
          readonly invoicedWithoutTax: number | null;
          readonly invoicedWithoutTaxBaseCurrency: number | null;
          readonly invoicedWithoutTaxProjectCurrency: number | null;
        } | null> | null;
        readonly unInvoicedTotal: {
          readonly unInvoicedMinutes: number | null;
          readonly unInvoicedPrice: number | null;
        };
        readonly currentProjectStatus: {
          readonly id: string;
          readonly color: string | null;
        } | null;
        readonly client: {
          readonly id: string;
          readonly name: string;
          readonly logoId: string | null;
          readonly logoDefaultId: number | null;
        } | null;
        readonly clientContact: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
        } | null;
        readonly rateCard: {
          readonly id: string;
          readonly name: string | null;
          readonly currency: string | null;
          readonly parentRateCardId: string | null;
          readonly defaultRate: number | null;
          readonly rates: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly rate: number | null;
                readonly startDate: string | null;
                readonly defaultRate: boolean | null;
                readonly role: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
        readonly expenseItems: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly approved: boolean | null;
              readonly expenseYear: number | null;
              readonly expenseMonth: number | null;
              readonly expenseDay: number | null;
              readonly billable: boolean | null;
              readonly partOfFixedPrice: boolean | null;
              readonly price: number | null;
              readonly cost: number | null;
              readonly quantity: number | null;
              readonly planned: boolean | null;
              readonly createdAt: string | null;
              readonly invoiceId: number | null;
              readonly invoiced: boolean | null;
              readonly deliverable: {
                readonly id: string;
                readonly price: number | null;
              } | null;
              readonly person: {
                readonly id: string;
                readonly fullName: string | null;
                readonly profilePictureId: string | null;
                readonly profilePictureDefaultId: number | null;
              } | null;
              readonly phase: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly retainerPeriods: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
              readonly startYear: number | null;
              readonly startMonth: number | null;
              readonly startDay: number | null;
              readonly endYear: number | null;
              readonly endMonth: number | null;
              readonly endDay: number | null;
              readonly periodPriceAmount: number | null;
              readonly periodHoursAmount: number | null;
              readonly periodLocked: boolean | null;
              readonly invoiced: boolean | null;
              readonly sharedPeriodDifferencePriceAmount: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectDropdown_projects">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "standaloneCreateInvoiceModalV2_viewer";
};
export type standaloneCreateInvoiceModalV2_viewer$key = {
  readonly " $data"?: standaloneCreateInvoiceModalV2_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"standaloneCreateInvoiceModalV2_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v0/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyExchangeRate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultPeriodBudgetType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v5/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentRateCardId",
      "storageKey": null
    },
    (v24/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "RateTypeConnection",
      "kind": "LinkedField",
      "name": "rates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RateTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Rate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v24/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "rates(first:10000)"
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientContact",
  "kind": "LinkedField",
  "name": "clientContact",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceId",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectInvoiceTotalType",
  "kind": "LinkedField",
  "name": "invoiceTotals",
  "plural": true,
  "selections": [
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoicedWithoutTax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoicedWithoutTaxBaseCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoicedWithoutTaxProjectCurrency",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "endDay",
      "variableName": "endDay"
    },
    {
      "kind": "Variable",
      "name": "endMonth",
      "variableName": "endMonth"
    },
    {
      "kind": "Variable",
      "name": "endYear",
      "variableName": "endYear"
    },
    {
      "kind": "Variable",
      "name": "startDay",
      "variableName": "startDay"
    },
    {
      "kind": "Variable",
      "name": "startMonth",
      "variableName": "startMonth"
    },
    {
      "kind": "Variable",
      "name": "startYear",
      "variableName": "startYear"
    }
  ],
  "concreteType": "UnInvoicedProjectTotal",
  "kind": "LinkedField",
  "name": "unInvoicedTotal",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unInvoicedMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unInvoicedPrice",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseItemTypeConnection",
  "kind": "LinkedField",
  "name": "expenseItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExpenseItemTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "approved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expenseYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expenseMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expenseDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "partOfFixedPrice",
              "storageKey": null
            },
            (v30/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "planned",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            (v27/*: any*/),
            (v31/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "DeliverableType",
              "kind": "LinkedField",
              "name": "deliverable",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v30/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                (v8/*: any*/),
                (v9/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseType",
              "kind": "LinkedField",
              "name": "phase",
              "plural": false,
              "selections": (v6/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100000
    }
  ],
  "concreteType": "RetainerPeriodTypeConnection",
  "kind": "LinkedField",
  "name": "retainerPeriods",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetainerPeriodTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RetainerPeriodType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodBudgetType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodPriceAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodHoursAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodLocked",
              "storageKey": null
            },
            (v31/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sharedPeriodDifferencePriceAmount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "retainerPeriods(first:100000)"
},
v34 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "DeprecatedProjectIndicatorJS_project"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isProjectInvoicing"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "standaloneCreateInvoiceModalV2_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiceLastSequence",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiceQuantityDecimals",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ExchangeRateTypeConnection",
          "kind": "LinkedField",
          "name": "dateEffectiveExchangeRates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExchangeRateTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExchangeRate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientTypeConnection",
          "kind": "LinkedField",
          "name": "clients",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Client",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "excludeClientUsers",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000000
            },
            {
              "kind": "Literal",
              "name": "onlyActive",
              "value": false
            }
          ],
          "concreteType": "PersonTypeConnection",
          "kind": "LinkedField",
          "name": "allPersons",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PersonDropdown_persons"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "allPersons(excludeClientUsers:false,first:1000000,onlyActive:false)"
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isProjectInvoicing",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "internalId",
              "variableName": "projectId"
            }
          ],
          "concreteType": "ProjectType",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v5/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v23/*: any*/),
            (v25/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Client",
              "kind": "LinkedField",
              "name": "client",
              "plural": false,
              "selections": (v6/*: any*/),
              "storageKey": null
            },
            (v26/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            (v32/*: any*/),
            (v33/*: any*/),
            (v34/*: any*/)
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isProjectInvoicing",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "excludeDoneOrHalted",
              "value": true
            }
          ],
          "concreteType": "ProjectTypeConnection",
          "kind": "LinkedField",
          "name": "projects",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProjectDropdown_projects"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v5/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/),
                    (v22/*: any*/),
                    (v23/*: any*/),
                    (v28/*: any*/),
                    (v29/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectStatus",
                      "kind": "LinkedField",
                      "name": "currentProjectStatus",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "color",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Client",
                      "kind": "LinkedField",
                      "name": "client",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v5/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "logoId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "logoDefaultId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v26/*: any*/),
                    (v25/*: any*/),
                    (v32/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "projects(excludeDoneOrHalted:true)"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "90b4d1bd10c57fa124d68fea558d1a83";

export default node;
